import http from '@/http';
import cookie from 'vue-cookies';
import Vue from 'vue';

export const state = {
    code: '',
    name: '',
    status: '',
    websocketPath: '',
    socket: '',
    history: [],

    // Players
    turn: '',
    host: '',
    players: [],

    // Cards
    deck: [],
    kings: [],
    latestCard: '',
    hasPicked: false,
};

export const mutations = {
    /**
     * Set multiple room attribute states
     * @param {Object} state - The state object
     * @param {Object} attributes - The attributes to set
     */
    SET_ROOM_ATTRIBUTES(state, attributes) {
        Object.entries(attributes).forEach((attribute) => {
            Vue.set(state, attribute[0], attribute[1]);
        });
    },

    /**
     *
     * @param {Object} state - The state object
     * @param {*} picked - Card has been picked boolean
     */
    SET_PICKED(state, picked) {
        state.hasPicked = picked;
    },
};

export const getters = {
    /**
     * Get room state
     * @param {object} state - The state object
     * @param {String} key - The attribute key
     */
    GET_ROOM_ATTRIBUTE: (state) => (key) => {
        return state[key];
    },

    /**
     * Get revealed card count
     */
    GET_REVEALED_CARD_COUNT: (state) => {
        return state.deck.find((card) => card.revealed).length;
    },
};

export const actions = {
    /**
     * Query the API for a room
     * @param {String} id - The ID of the room to get
     */
    GET_ROOM({ dispatch }, id) {
        const player = cookie.get('player');
        const data = {
            params: {
                player_id: player ? player.player_id : '',
            },
        };

        return new Promise((resolve, reject) => {
            http.get(`rooms/${id}`, data)
                .then((object) => {
                    if (object.data.can_join) {
                        dispatch('SET_ROOM', object.data);
                        resolve(object);
                    } else {
                        const error = new Error(
                            'Room cannot be joined as the game has already started.',
                        );
                        reject(error);
                    }
                })
                .catch(() => {
                    reject(new Error('There has been an error.'));
                });
        });
    },

    /**
     * Set the room
     * @param {Object} roomData - The room data object
     */
    SET_ROOM({ commit }, roomData) {
        commit('SET_ROOM_ATTRIBUTES', {
            code: roomData.code,
            name: roomData.name,
            status: roomData.status,
            websocketPath:
                process.env.VUE_APP_WEBSOCKET_HOSTNAME +
                roomData.websocket_path,
        });
    },

    /**
     * Post to the API and store the room in state
     * @param {*} payload - The room payload
     */
    CREATE_ROOM({ dispatch }, payload) {
        return new Promise((resolve, reject) => {
            http.post('rooms/', payload)
                .then((object) => {
                    dispatch('SET_ROOM', object.data);
                    resolve(object);
                })
                .catch((error) => reject(error));
        });
    },
};
